import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    gameplay: {},
};

export const gameplaySlice = createSlice({
    name: 'gameplay',
    initialState,
    reducers: {
        setGameplay(state, action) {
            state.gameplay = action.payload;
        },
    }
});

export default gameplaySlice;